import { render } from "./additionalInfo.vue?vue&type=template&id=ca849ce6&scoped=true"
import script from "./additionalInfo.vue?vue&type=script&lang=js"
export * from "./additionalInfo.vue?vue&type=script&lang=js"

import "./additionalInfo.vue?vue&type=style&index=0&id=ca849ce6&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca849ce6"]])

export default __exports__